/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import imgError from '@/assets/images/error.png'
import { consultarCep } from '@/services/consultaCep'

Vue.use(Vuex)

const store = {
   state: {
      // urlRest: 'http://10.0.0.209/rest/',
      // urlRest: 'http://131.196.199.117:8080/erp-jair-nilson/api/v1/',
      // urlRest: 'https://adminescalador.oneway.tec.br/erp-jair-nilson/api/v1/',
      // urlRest: 'https://unmanifest-unsecretarial-erline.ngrok-free.dev/erp-jair-nilson/api/v1/',
      urlRest: 'https://selections-font-discussions-shift.trycloudflare.com/erp-jair-nilson/api/v1/',
      loadingCount: 0,
      isLogado: false,
      dadosUsuario: null,
      tokenSessao: null,
      dadosEmpresa: null,
      tabs: [],
      fontSizeDataLabels: localStorage.getItem('fontSizeDataLabels') ? parseInt(localStorage.getItem('fontSizeDataLabels')) : 14,
      secoes: {
         'pagina-inicial': {
            nome: 'Página Inicial',
            icon: 'fal fa-home',
            tabs: [
               { nome: 'Página Inicial', path: '/paginaInicial', icon: 'bx bx-home-circle', ativa: true, role: null }
            ]
         },
         'perfil': {
            nome: 'Perfil',
            icon: 'fal fa-user',
            tabs: [
               { nome: 'Perfil', path: '/perfil', icon: 'bx bx-user', ativa: true, role: null }
            ]
         },
         'representantes': {
            nome: 'Representantes',
            icon: 'fal fa-walking',
            tabs: [
               { nome: 'Representantes', path: '/representantes', icon: 'bx bx-id-card', ativa: true, role: null },
               { nome: 'Usuários', path: '/representantes/usuarios', icon: 'bx bx-user', ativa: false, role: null },
            ]
         },
         'planos': {
            nome: 'Planos',
            icon: 'fal fa-money-bill',
            tabs: [
               { nome: 'Planos', path: '/planos', icon: 'bx bx-money', ativa: true, role: null },
               { nome: 'Tabelas de preços', path: '/planos/tabelas', icon: 'bx bx-table', ativa: false, role: null },
            ]
         },
         'empresas': {
            nome: 'Empresas',
            icon: 'fal fa-money-bill',
            tabs: [
               { nome: 'Empresas', path: '/empresas', icon: 'bx bx-building', ativa: true, role: null },
               { nome: 'Gestores', path: '/empresas/gestores', icon: 'bx bx-folder', ativa: false, role: null },
               { nome: 'Grupos empresariais', path: '/empresas/grupos', icon: 'bx bx-folder', ativa: false, role: null },
            ]
         },
         'contabilidades': {
            nome: 'Contabilidades',
            icon: 'far fa-calculator',
            tabs: [
               { nome: 'Contabilidades', path: '/contabilidades', icon: 'bx bx-calculator', ativa: true, role: null },
               { nome: 'Usuários contábeis', path: '/contabilidades/usuarios', icon: 'bx bx-user', ativa: false, role: null },
            ]
         },
         'assinaturas': {
            nome: 'Assinaturas',
            icon: 'fas fa-file-signature',
            tabs: [
               { nome: 'Assinaturas', path: '/assinaturas', icon: 'bx bx-edit', ativa: true, role: null },
            ]
         },
         'relatorios': {
            nome: 'Relatórios',
            icon: 'bx bx-bar-chart-alt-2',
            tabs: [
               { nome: 'Dashboard', path: '/relatorios', icon: 'bx bx-bar-chart-alt-2', ativa: true, role: null },
               { nome: 'Dinamicos', path: '/relatorios-dinamicos', icon: 'bx bx-chart', ativa: false, role: null }
            ]
         },
         'changelog': {
            nome: 'Changelog',
            icon: 'bx bx-history',
            tabs: [
               { nome: 'Changelog', path: '/changelog', icon: 'bx bx-history', ativa: true, role: null }
            ]
         },
         'tutoriais': {
            nome: 'Tutoriais',
            icon: 'bx bx-video',
            tabs: [
               { nome: 'Tutoriais', path: '/tutoriais', icon: 'bx bx-video', ativa: true, role: null }
            ]
         },
         'atualizacoes': {
            nome: 'Atualizações Sistema',
            icon: 'bx bx-sync',
            tabs: [
               { nome: 'Atualizações', path: '/atualizacoes', icon: 'bx bx-sync', ativa: true, role: null }
            ]
         },
         'support': {
            nome: 'Suporte / Report',
            icon: 'bx bx-support',
            tabs: [
               { nome: 'Meus Tickets', path: '/sistema/suporte/tickets', icon: 'bx bx-list-ul', ativa: true, role: null },
               { nome: 'Reportar', path: '/sistema/reportar-suporte', icon: 'bx bx-support', ativa: false, role: null }
            ]
         }
      },
      secaoAtiva: 'pagina-inicial'
   },
   mutations: {
      setLoading: (state, payload) => {
         if (typeof payload === 'boolean') {
            state.loadingCount = payload ? Math.max(state.loadingCount + 1, 1) : Math.max(state.loadingCount - 1, 0)
         } else if (typeof payload === 'number') {
            state.loadingCount = Math.max(0, state.loadingCount + payload)
         }
      },
      imageError: (state, e) => {
         e.target.src = imgError
      },
      addTabData: (state, route) => {
         let index = state.tabs.findIndex(tab => tab.id == route.id)
         // console.log('NEW Size: '+ state.tabs.length +' / '+ 'idTab: '+ route.id)

         if (index == -1) {
            state.tabs.push(route)
         }
      },
      attTabData: (state, route) => {
         let index = state.tabs.findIndex(tab => tab.id == route.id)
         // console.log('ATT Size: '+ state.tabs.length +' / '+ 'idTab: '+ route.id)

         if (index != -1) {
            state.tabs[index].data = route.data
            Vue.prototype.$set(state.tabs, index, state.tabs[index])
         }
      },
      deleteTabData: (state, index) => {
         // console.log('DEL Size: '+ state.tabs.length +' / '+ 'index: '+ index)
         state.tabs.splice(index, 1)

         if (state.tabs.length > 0) {
            state.tabs.forEach((tab, index) => {
               tab.id = index
               tab.path = tab.path.substring(0, tab.path.lastIndexOf("/") + 1) + index
            });

            let lastTab = state.tabs[state.tabs.length - 1]
            /* eslint-disable-next-line no-useless-escape */
            router.push(lastTab.path + "?" + JSON.stringify(lastTab.query).replace(/[\{\}]|["]/g, "").replace(/[:]/g, "=").replace(/[,]/g, "&")).catch()
         }
      },
      deleteTabs: state => {
         router.push('/paginaInicial/0')
         state.tabs.splice(1, state.tabs.length)
      },
      verificarCredenciais: (state, credenciais) => {
         // Se credenciais não foram passadas, verificar se há credenciais salvas no localStorage
         if (!credenciais && (localStorage.email || localStorage.cnpj) && localStorage.password) {
            credenciais = {
               "email": localStorage.email ? localStorage.email.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("") : null,
               "cnpj": localStorage.cnpj ? localStorage.cnpj.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("") : null,
               "password": localStorage.password.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join(""),
               "manterConectado": true // Se está vindo do localStorage, significa que estava marcado
            };
         }

         if (!credenciais) {
            return
         }

         if ((credenciais.cnpj == null || credenciais.cnpj.trim().length == 0) && (credenciais.email == null || credenciais.email.trim().length == 0)) {
            Vue.prototype.$toast.fire({
               icon: 'error',
               title: 'CNPJ ou Email inválido!'
            })
            return
         }
         if (credenciais.password == null || credenciais.password.trim().length == 0) {
            Vue.prototype.$toast.fire({
               icon: 'error',
               title: 'Senha inválida!'
            })
            return
         }

         state.loadingCount++
         Vue.prototype.$axios({
            method: 'post',
            url: state.urlRest + 'auth/login/gerencial',
            headers: { 'Content-Type': 'application/json' },
            data: {
               "cnpj": credenciais.cnpj || null,
               "email": credenciais.email || null,
               "password": credenciais.password
            }
         }).then(function (response) {
            state.dadosUsuario = response.data
            state.isLogado = true

            // Pega o token do header (X-Auth-Token) OU do corpo
            let token = response.headers && response.headers['x-auth-token']
            if (!token && response.headers && response.headers.get) {
               token = response.headers.get('X-Auth-Token');
            }
            if (!token && response.data.tokenSessao) {
               token = response.data.tokenSessao
            }
            state.tokenSessao = token

            if (token) {
               localStorage.setItem('tokenSessao', token)
               Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            }

            if (credenciais.manterConectado) {
               // Salvar email se existir
               if (credenciais.email) {
                  localStorage.email = credenciais.email.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               }
               // Salvar cnpj se existir
               if (credenciais.cnpj) {
                  localStorage.cnpj = credenciais.cnpj.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               }
               // Sempre salvar a senha
               localStorage.password = credenciais.password.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
            }

            if (router.currentRoute.path !== '/paginaInicial') {
               router.push('/paginaInicial')
            }

         }).catch(function (error) {
            store.mutations.deslogar(state)
            if (error.response != undefined) {
               if (error.response.status == 401 || error.response.status == 404) {
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: 'Credenciais incorretas!'
                  });
               } else {
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               Vue.prototype.$toast.fire({
                  icon: 'error',
                  title: 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'
               });
            }
         }).finally(() => {
            state.loadingCount--
         });
      },
      deslogar: state => {
         // Chamar o endpoint de logout
         Vue.prototype.$axios({
            method: 'post',
            url: state.urlRest + 'auth/logout',
            data: {},
            headers: { 'Content-Type': 'application/json' }
         }).catch(function (error) {
            console.error('Erro ao fazer logout:', error);

         }).finally(() => {

            state.dadosUsuario = null
            state.isLogado = false
            state.dadosEmpresa = null
            state.tabs = []
            state.secaoAtiva = 'pagina-inicial'
            if (router.currentRoute.path !== '/paginaInicial') {
               router.push('/paginaInicial')
            }

            localStorage.removeItem('email')
            localStorage.removeItem('cnpj')
            localStorage.removeItem('password')
            localStorage.removeItem('tokenSessao')
            // Limpa Authorization global
            if (Vue.prototype.$axios && Vue.prototype.$axios.defaults && Vue.prototype.$axios.defaults.headers.common['Authorization']) {
               delete Vue.prototype.$axios.defaults.headers.common['Authorization']
            }
         });
      },
      alternarTelaCarregamento: (state, valor) => {
         state.loadingCount = state.loadingCount + valor;
      },
      alterarAvatar: (state, avatar) => {
         state.dadosUsuario.avatar = avatar;
      },
      setFontSizeDataLabels: (state, value) => {
         // Garantir que o valor esteja entre 10 e 30
         if (value >= 10 && value <= 30) {
            state.fontSizeDataLabels = value;
            // Salvar no localStorage
            localStorage.setItem('fontSizeDataLabels', value.toString());
         }
      },
      setSecaoAtiva: (state, secao) => {
         state.secaoAtiva = secao;
         // Resetar todas as tabs da seção para inativa
         Object.keys(state.secoes).forEach(key => {
            state.secoes[key].tabs.forEach(tab => {
               tab.ativa = false;
            });
         });
         // Ativar a primeira tab da seção
         if (state.secoes[secao] && state.secoes[secao].tabs.length > 0) {
            state.secoes[secao].tabs[0].ativa = true;
         }
      },
      ativarTab: (state, { secao, tabIndex }) => {
         // Desativar todas as tabs da seção
         state.secoes[secao].tabs.forEach(tab => {
            tab.ativa = false;
         });
         // Ativar a tab selecionada
         if (state.secoes[secao].tabs[tabIndex]) {
            state.secoes[secao].tabs[tabIndex].ativa = true;
         }
      },
      setDadosEmpresa: (state, empresa) => {
         state.dadosEmpresa = empresa;
      }
   },
   actions: {
      imageError: ({ commit }, e) => {
         commit('imageError', e)
      },
      addTabData: ({ commit }, route) => {
         commit('addTabData', route)
      },
      attTabData: ({ commit }, route) => {
         commit('attTabData', route)
      },
      deleteTabData: ({ commit }, index) => {
         commit('deleteTabData', index)
      },
      toggleTelaAjuda: ({ commit }, tela) => {
         commit('toggleTelaAjuda', tela)
      },
      verificarCredenciais: ({ commit }, credenciais) => {
         commit('verificarCredenciais', credenciais)
      },
      verificarAutoLogin: ({ commit }) => {
         // Verificar se há credenciais salvas no localStorage
         if ((localStorage.email || localStorage.cnpj) && localStorage.password) {
            commit('verificarCredenciais', null) // Passar null para usar credenciais do localStorage
         }
      },
      alternarTelaCarregamento: ({ commit }, valor) => {
         commit('alternarTelaCarregamento', valor)
      },
      alterarAvatar: ({ commit }, avatar) => {
         commit('alterarAvatar', avatar)
      },
      deleteTabs: context => context.commit('deleteTabs'),
      deslogar: context => context.commit('deslogar'),
      setSecaoAtiva: ({ commit }, secao) => {
         commit('setSecaoAtiva', secao)
      },
      ativarTab: ({ commit }, { secao, tabIndex }) => {
         commit('ativarTab', { secao, tabIndex })
      },
      setDadosEmpresa: ({ commit }, empresa) => {
         commit('setDadosEmpresa', empresa)
      },
      buscarCEP: ({ state, commit }, cep) => {
         return new Promise((resolve, reject) => {
            consultarCep(cep).then(data => {
               resolve(data)
            }).catch(function (error) {
               Vue.prototype.$toast.fire({
                  icon: 'error',
                  title: 'Erro: ' + error.message,
               });
               reject(null)
            }).finally(() => {
               state.loadingCount = state.loadingCount - 1;
            });
         })
      },
      buscarCNPJ: ({ state, commit }, cnpj) => {
         return new Promise((resolve, reject) => {
            Vue.prototype.$axios({
               method: 'get',
               url: state.urlRest + `consultas/cnpj/${cnpj}`
            }).then(response => {
               if (response.data == null) {
                  reject(null)
               } else {
                  resolve(response.data)
               }
            }).catch((error) => {
               if (error.response != undefined) {
                  const msg = error.response.data?.message || 'Erro: CNPJ inválido ou não encontrado';
                  Vue.prototype.$toast.fire({
                     icon: 'error',
                     title: msg,
                  });
               }
               reject(null)
            }).finally(() => {
               state.loadingCount = state.loadingCount - 1;
            });
         });
      },
      formatValue: ({ commit }, data) => {
         return new Promise((resolve, reject) => {
            let value = String(data.valor).replace(/[^\d-]/g, '');

            while (value.length <= data.digitos) {
               value = '0' + value;
            }

            if (data.digitos === 0) {
               resolve(parseInt(value));
            } else {
               resolve(parseInt(value.slice(0, -data.digitos)) + '.' + value.slice(-data.digitos))
            }
         })
      },
      base64toFile: ({ commit }, base64Data) => {
         return new Promise((resolve, reject) => {
            if (base64Data.length == 0) {
               resolve([])
            }

            for (let i = 0; i < base64Data.length; i++) {
               if (String(base64Data[i]).startsWith('data:')) {
                  let byteCharacters = atob(base64Data[i].split(';base64,').pop());
                  let byteNumbers = new Array(byteCharacters.length);

                  for (let i = 0; i < byteCharacters.length; i++) {
                     byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }

                  let blob = new Blob([new Uint8Array(byteNumbers)], { type: 'image/png' });
                  base64Data[i] = new File([blob], 'imagem.png', { type: blob.type });
               }

               if (i == (base64Data.length - 1)) {
                  resolve(base64Data)
               }
            }
         })
      },

   },
   modules: {
   }
}

export default new Vuex.Store(store);
